import { motion } from "framer-motion";
import { Apple, Play, Smartphone, QrCode } from "lucide-react";

const PhoneMock = ({ className = "", accent = "#1E3A8A" }) => (
  <div className={`h-[340px] w-[190px] rounded-[2.2rem] border-4 border-white/20 bg-white/10 p-2.5 shadow-[0_24px_60px_rgba(0,0,0,0.4)] backdrop-blur-md ${className}`}>
    <div className="flex h-full flex-col rounded-[1.7rem] bg-white p-2.5 text-slate-900">
      <div className="mx-auto mt-1 h-1.5 w-14 rounded-full bg-slate-200" />
      <div className="mt-3 rounded-xl p-2.5" style={{ backgroundColor: `${accent}12` }}>
        <p className="text-[11px] font-semibold" style={{ color: accent }}>Abay AI</p>
        <p className="mt-1 text-[11px] leading-snug text-slate-600">Found 12 villas in Bole under ETB 25M</p>
      </div>
      <div className="mt-2.5 space-y-2">
        {[1, 2, 3].map((i) => (
          <div key={i} className="flex items-center gap-2 rounded-xl border border-slate-100 p-1.5">
            <div className="h-9 w-11 rounded-lg bg-slate-100" />
            <div className="flex-1">
              <div className="h-2 w-3/4 rounded bg-slate-200" />
              <div className="mt-1 h-2 w-1/2 rounded bg-slate-100" />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const MobileApp = () => {
  return (
    <section className="bg-[#0F1F45] py-12 sm:py-16" data-testid="mobile-app-section">
      <div className="abay-container">
        <div className="overflow-hidden rounded-3xl border border-white/10 bg-[#1E3A8A] text-white shadow-[var(--shadow-lg)]">
          <div className="grid items-center gap-8 p-8 sm:p-12 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1.5 text-sm backdrop-blur-md">
                <Smartphone className="h-4 w-4" /> ABAY360 Mobile
              </span>
              <h2 className="mt-5 text-3xl font-bold tracking-tight sm:text-4xl">Ethiopia&apos;s property market, in your pocket</h2>
              <p className="mt-4 max-w-lg text-white/80">
                Search with AI, save favorites, chat with agents and get instant alerts — anywhere, anytime.
              </p>

              <div className="mt-6">
                <span data-testid="mobile-app-coming-soon" className="inline-flex items-center gap-1.5 rounded-full bg-[#10B981]/20 px-3 py-1 text-xs font-semibold text-white ring-1 ring-[#10B981]/40">
                  Coming Soon
                </span>
              </div>

              <div className="mt-4 flex flex-wrap items-center gap-3">
                <button type="button" disabled aria-disabled="true" data-testid="appstore-button"
                  className="flex cursor-default items-center gap-3 rounded-xl bg-white/95 px-5 py-3 text-slate-900 opacity-95">
                  <Apple className="h-6 w-6" />
                  <span className="text-left leading-tight">
                    <span className="block text-xs text-slate-500">Download on the</span>
                    <span className="block text-sm font-semibold">App Store</span>
                  </span>
                </button>
                <button type="button" disabled aria-disabled="true" data-testid="playstore-button"
                  className="flex cursor-default items-center gap-3 rounded-xl bg-white/95 px-5 py-3 text-slate-900 opacity-95">
                  <Play className="h-6 w-6 fill-[#10B981] text-[#10B981]" />
                  <span className="text-left leading-tight">
                    <span className="block text-xs text-slate-500">Get it on</span>
                    <span className="block text-sm font-semibold">Google Play</span>
                  </span>
                </button>

                <div className="flex items-center gap-3" data-testid="mobile-app-qr">
                  <span className="flex h-[52px] w-[52px] items-center justify-center rounded-xl bg-white text-[#1E3A8A] shadow-[0_8px_20px_rgba(0,0,0,0.25)]">
                    <QrCode className="h-9 w-9" strokeWidth={1.4} />
                  </span>
                  <span className="text-xs leading-tight text-white/75">Scan to<br />download</span>
                </div>
              </div>
            </div>

            {/* Dual phone mockups */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              className="relative hidden h-[380px] items-center justify-center lg:flex"
            >
              <PhoneMock className="absolute -rotate-6 -translate-x-16 scale-90 opacity-90" accent="#0E9F6E" />
              <PhoneMock className="relative rotate-3 translate-x-10" accent="#1E3A8A" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
